import { Row, Col } from 'antd';
import { useParams } from 'react-router-dom';

import { Report } from './Report';
import { useGetReport } from './hooks';
import { useSearchParams } from '@/hooks';
import { Text } from '@/components/Typography';
import { PersonalisedReportProvider } from './context';
import { LoadingSkeleton } from './context/LoadingSkeleton';
import { useApplicationContext } from '@/context/Application';
import { PersonalisedReportRouteParams, PersonalisedReportSearchParams } from './context/types';

export function PersonalisedReport(): JSX.Element {
	const { organization, company } = useApplicationContext();
	const { report_id, file_id } = useParams<PersonalisedReportRouteParams>();

	const {
		organization_id = organization.id,
		company_id = company.id,
		current_sequence = '',
		id
	} = useSearchParams<PersonalisedReportSearchParams>();

	const { isFetching, isLoading, data, isError } = useGetReport({
		id,
		file_id,
		report_id,
		company_id,
		organization_id,
		current_sequence: current_sequence ? Number(current_sequence) : null
	});

	if (isError) {
		return <Text>Oops... Something went wrong!</Text>;
	}

	if (isFetching || isLoading) {
		return <LoadingSkeleton />;
	}

	return (
		<Row>
			<Col xs={24}>
				<PersonalisedReportProvider personalisedReport={data}>
					<Report />
				</PersonalisedReportProvider>
			</Col>
		</Row>
	);
}
